<template>
  <v-flex class="pa-0 main fill-height" fluid>
    <v-layout>
      <v-flex md12>
        <div>
          <v-layout row wrap justify-end>
            <v-flex md2>
              <NavDrawer />
            </v-flex>
            <v-flex md9 class="ma-0 pa-0">
              <div class="headline">Report Device Configuration</div>
              <v-divider></v-divider>
              <v-layout row wrap>
                <v-flex md5 ma-2 pa-2>
                  <v-layout column>
                    <v-flex>
                      <v-toolbar>
                        <v-toolbar-title>Report Templates</v-toolbar-title>
                      </v-toolbar>
                      <div class="device-list">
                        <v-card height=80 v-for="template in templates" :key="template.template"
                          ripple>
                          <v-list>
                            <v-card-text>
                              <v-list-tile v-model="selectedTemplates" multiple :value="template"
                                @click="selectedTemplateEdit(template)">
                                <v-list-tile-content>
                                  {{template.title}}
                                  <div class="grey--text">
                                    {{template.description}}
                                  </div>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card-text>
                          </v-list>
                        </v-card>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md5 ma-2 pa-2>
                  <v-layout column>
                    <v-flex class="card-border">
                      <v-toolbar>
                        <v-toolbar-title>Selected Templates</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-btn icon :disabled="isSelectedTemplateEmpty" @click="insertOrUpdateData">
                          <v-icon>save</v-icon>
                        </v-btn>

                        <v-btn icon :disabled="isSelectedTemplateEmpty || !templateExists"
                          @click="deleteTemplate">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <div class="device-list">
                        <v-card>
                          <v-list>
                            <v-list-tile v-if="templateLoading">
                              <v-list-tile-content>
                                <v-progress-circular indeterminate color="primary">
                                </v-progress-circular>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-card v-for="(item, index) in selectedTemplates" :key="index"
                              @mouseenter="hoverItem = item.title">
                              <v-layout>
                                <v-flex>
                                  <v-card-text>
                                    <div class="selectedTemp">
                                      <v-list-tile pa-0>
                                        {{item.title}}
                                      </v-list-tile>
                                    </div>
                                  </v-card-text>
                                </v-flex>
                              </v-layout>
                            </v-card>
                            <v-list-tile v-if="isSelectedTemplateEmpty">
                              <v-list-tile-content>
                                <v-list-tile-title v-text="message" color="gray">
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-card>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Report from '@/services/customReportConfig'
import NavDrawer from '@/components/common/NavDrawer.vue'

export default {
  components: {
    NavDrawer
  },
  data() {
    return {
      hoverItem: '',
      selectedTemplates: [],
      templates: [],
      templateExists: false,
      message: '',
      templateLoading: false,
      responseMessage: '',
      showSnackbar: false
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    isSelectedTemplateEmpty() {
      return this.selectedTemplates.length === 0
    }
  },
  async mounted() {
    await this.fetchData()
    await this.fetchTemplate()
  },
  methods: {
    selectedTemplateEdit(template) {
      let templateExists = this.selectedTemplates.some((s) => {
        return s.title == template.title
      })
      if (templateExists == true) {
        let tempSelectedTemplate = this.selectedTemplates.filter((tem) => {
          return tem.title != template.title
        })
        this.selectedTemplates = tempSelectedTemplate
      } else {
        this.selectedTemplates.push(template)
      }
    },
    async fetchData() {
      try {
        const response = await Report.fetchTemplates()
        this.templates = [...response.data]
      } catch (err) {
        console.log(err, 'ERROR in fetchData')
      }
    },
    async fetchTemplate() {
      this.templateLoading = true
      try {
        const response = await Report.fetchPlantTemplate(this.getSelectedPlantId)
        this.templateLoading = false
        if (response.status === 200) {
          this.selectedTemplates = response.data.list.map(item => {
            const keys = this.templates.map(x => x.template)
            return this.templates[keys.indexOf(item.template)]
          })
          this.templateExists = true
        }
      } catch (err) {
        this.templateLoading = false

        this.selectedTemplates = []
        this.templateExists = false
        if (err.response.status === 404) {
          this.message = 'No template for selected plant'
        } else {
          this.message = 'There was an error loading the template. Please try again.'
        }
      }
    },
    insertOrUpdateData() {
      if (this.templateExists) {
        Report.updateTemplates({
          id: this.getSelectedPlantId,
          reports: this.selectedTemplates.map(item => item.template)
        }).then(() => {
          this.showSnackbar = true
          this.responseMessage = 'Template is successfully updated.'
        }).catch(() => {
          this.showSnackbar = true
          this.responseMessage = 'There was some issue while making the change.'
        })
      } else {
        Report.insertTemplates({
          id: this.getSelectedPlantId,
          reports: this.selectedTemplates.map(item => item.template)
        }).then(() => {
          this.showSnackbar = true
          this.responseMessage = 'Template is successfully created.'
        }).catch(() => {
          this.showSnackbar = true
          this.responseMessage = 'There was some issue while making the change.'
        })
        this.templateExists = true
      }
    },
    deleteTemplate() {
      Report.deleteTemplate(this.getSelectedPlantId).then(() => {
        this.selectedTemplates = []
        this.templateExists = false
        this.showSnackbar = true
        this.responseMessage = 'Template has been deleted.'
      }).catch(err => {
        console.log(err)
        this.showSnackbar = true
        this.responseMessage = 'There was some issue while making the change.'
      })
    }
  },
  watch: {
    getSelectedPlantId() {
      this.fetchTemplate(this.getSelectedPlantId)
    }
  }
}
</script>

<style scoped>
.headline{
  margin: 20px;
}
.active-item {
  background: red;
}
.selectedTemp {
  height: 100%;
  padding: 8px 12px 0px;
}
.device-list{
  max-height: 540px;
  min-height: 540px;
  overflow-y: auto;
}
.card-border{
  border-bottom: 2px solid black;
}
</style>
